import styled from "styled-components"

export const ContentBlockquoteDIV = styled.div`
  border-left: 3px solid var(--color--slate-500);
  margin: 0 0 var(--spacing--base-1-25);
  padding: var(--spacing--XS) var(--spacing--S);

  blockquote {
    position: relative;
    
    &,
    & p {
      font-size: var(--font-size--XL);
      font-weight: var(--font-weight--light);
      line-height: var(--line-height--relaxed);
    }

    & p:last-of-type {
      margin-bottom: 0;
    }

    &::before {
      content: "“";
      position: absolute;
      display: block;
      top: auto;
      left: -0.4em;
    }

    p:last-of-type::after {
      content: "”";
      display: inline;
    }
  }

  blockquote p:last-child {
    margin-bottom: 0;
  }

  .AvatarWithName,
  .AvatarPlusInfo {
    margin-top: var(--spacing--S);
  }

  // L variant styles
  &.variant--L {
    border-left: none;
    padding: 0 0 0 var(--spacing--base-3);

    blockquote {
      &,
      & p {
        font-size: var(--font-size--5XL);
        font-family: var(--font-family--serif);
        font-feature-settings: var(--font-family--serif--font-feature-settings);
        font-weight: var(--font-weight--normal);
        line-height: var(--line-height--tighter);
      }

      &::before {
        left: -0.33em;
      }
    }
  }
`
